var Editor = require('./editor');
module.exports = Editor;



/*****************
 ** WEBPACK FOOTER
 ** ./~/substance/ui/editor/index.js
 ** module id = 250
 ** module chunks = 0
 **/